<div class="title-wrap">
  <span>Videos von <a href="https://video.tt.com/" target="_blank">video.tt.com</a></span>
</div>
<div class="frame-wrap">
  @if(showVideoIFrame) {
    <iframe
      [src]="buildEmbedUrl(selectedVideo) | sanitizeUrl"
      [attr.title]="(selectedVideo.title | decodeHtmlString) || 'Eingebettetes Video'"
      width="100%"
      height="400"
      allow="autoplay"
      allowFullscreen
    ></iframe>
  } @else {
    <button class="thumb-overlay" (click)="toggleThumb()">
      <img class="thumb" [src]="selectedVideo.pictureBaseUrl" [alt]="selectedVideo.title | decodeHtmlString" />
      <div class="icon-overlay">
        <!-- use css styling for play icon because MatIcons don't work on video.tt.com -->
        <div class="play-icon"></div>
      </div>
    </button>
  }
</div>
<div class="text-wrap-default">
  <div class="title">
    {{ selectedVideo.title | decodeHtmlString }}
  </div>
  <div class="grey">
    {{ selectedVideo.timestamp | date : 'short' }}  
  </div>
</div>

@if(groups.length > 0) {
  <nmo-content-slider
    [hasArrowNav]="true"
    [hasPointNav]="false"
    [autoslideOn]="false"
    (indexChanged)="slideChanged($event)"
    [selectedIndex]="currentSlideIndex"
    [slides]="groups"
  >
    @for (group of groups; track groupIdx; let groupIdx = $index) {
      <nmo-content-slider-item [position]="groupIdx">
        @if (showSlide(groupIdx)) {
          <div class="slide">
            @for (video of group; track itemIdx; let itemIdx = $index) {
              <a
                class="inslide-item"
                [ngClass]="{ active: video === selectedVideo, loading: !video }"
                (click)="selectVideo(groupIdx, itemIdx)"
                (keydown)="selectVideo(groupIdx, itemIdx)"
                tabindex="0"
              >
                @if (video) {
                    <div class="image-wrap">
                      <img 
                        [src]="video.pictureBaseUrl" 
                        [srcset]="buildImgSourceSet(video)" 
                        [alt]="video.title | decodeHtmlString">
                    </div>
                    <div class="text-wrap" [innerHTML]="video.title"></div>

                }
              </a>
            }
          </div>
        }
      </nmo-content-slider-item>
    }
  </nmo-content-slider>
}

